import { trace } from 'rytm-helpers'

export const initCarouselNav = () => {
  const docEl = document.documentElement
  docEl.addEventListener("slide.bs.carousel", onCarouselSlide)
}

const onCarouselSlide = (e) => {
  const navPrev = e.target.querySelector(".carousel-control-prev")
  const navNext = e.target.querySelector(".carousel-control-next")
  if (navPrev && navNext) {
    const list = [...e.target.querySelectorAll(".carousel-item")]
    const lastIndex = list.length - 1
    switch (e.to) {
      case 0:
        navPrev.classList.remove("active")
        navNext.classList.add("active")
        break;
      case lastIndex:
        navPrev.classList.add("active")
        navNext.classList.remove("active")
        break;
      default:
        navPrev.classList.add("active")
        navNext.classList.add("active")
        break;
    }
  }
}